import * as React from "react";

// // // //

// Tailwind Breakpoints
const TAILWIND_MD = 768;
const TAILWIND_LG = 1024;
const TAILWIND_XL = 1280;
const TAILWIND_2XL = 1536;

export interface WindowSizeState {
    width: number;
    height: number;
    isSm: boolean;
    isMd: boolean;
    isLg: boolean;
    isXl: boolean;
    is2xl: boolean;
}

export function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    const [windowSize, setWindowSize] = React.useState<WindowSizeState>({
        width: -1,
        height: -1,
        isSm: false,
        isMd: false,
        isLg: false,
        isXl: false,
        is2xl: false,
    });

    React.useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            const width = window.innerWidth;

            // Set window width/height to state
            setWindowSize({
                width,
                height: window.innerHeight,
                isSm: width < TAILWIND_MD,
                isMd: width >= TAILWIND_MD && width < TAILWIND_LG,
                isLg: width >= TAILWIND_LG && width < TAILWIND_XL,
                isXl: width >= TAILWIND_XL && width < TAILWIND_2XL,
                is2xl: width >= TAILWIND_2XL,
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
}
// // // //
